/**
 * routes generator
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
/** path builder */

var PathBuilder =
/** @class */
function () {
  /**
   * constructor
   * @param parts path parts
   */
  function PathBuilder(parts) {
    if (parts === void 0) {
      parts = [];
    }

    this.parts = parts;
  }
  /**
   * returns new route generator with added path
   * @param part path part
   */


  PathBuilder.prototype.addPart = function (part) {
    return new PathBuilder(this.parts.concat(part));
  };
  /**
   * path string
   */


  PathBuilder.prototype.toString = function () {
    return this.parts.map(function (part) {
      return "/" + part;
    }).join("");
  };

  return PathBuilder;
}();

exports.PathBuilder = PathBuilder; // tslint:disable-next-line no-shadowed-variable

function routes(rootPath, routes) {
  var pathBuilder = new PathBuilder();

  var _routes = routes ? routes : rootPath; // tslint:disable-next-line no-object-literal-type-assertion


  var newChildren = {};

  for (var _i = 0, _a = Object.keys(_routes); _i < _a.length; _i++) {
    var key = _a[_i];
    newChildren[key] = _routes[key].bind(pathBuilder.addPart(key));
  }

  newChildren.toString = !rootPath ? function () {
    throw new Error("toString() not allowed");
  } : function () {
    return "/";
  };
  return newChildren;
}

exports.routes = routes;

function collection(parentPath, children) {
  if (typeof parentPath === "boolean") {
    return collectionWithChildren(parentPath, children);
  } else if (parentPath) {
    return collectionWithChildren(true, parentPath);
  } else {
    return collectionSimple();
  }
}

exports.collection = collection;

function collectionWithChildren(parentPath, children) {
  function collectionWithChildrenPathPart() {
    var _this = this; // tslint:disable-next-line no-object-literal-type-assertion


    var newChildren = {};

    for (var _i = 0, _a = Object.keys(children); _i < _a.length; _i++) {
      var key = _a[_i];
      newChildren[key] = children[key].bind(this.addPart(key));
    }

    newChildren.toString = parentPath ? function () {
      return _this.toString();
    } : function () {
      throw new Error("toString() not allowed");
    };
    return newChildren;
  }

  return collectionWithChildrenPathPart;
}

function collectionSimple() {
  function collectionSimplePathPart() {
    return this.toString();
  }

  return collectionSimplePathPart;
}

function member(parentPath, children) {
  if (typeof parentPath === "boolean") {
    return memberWithChildren(parentPath, children);
  } else if (parentPath) {
    return memberWithChildren(true, parentPath);
  } else {
    return memberSimple();
  }
}

exports.member = member;

function memberWithChildren(parentPath, children) {
  function memberWithChildrenPathPart(id) {
    // tslint:disable-next-line no-object-literal-type-assertion
    var newChildren = {};
    var pathBuilder = this.addPart(id);

    for (var _i = 0, _a = Object.keys(children); _i < _a.length; _i++) {
      var key = _a[_i];
      newChildren[key] = children[key].bind(pathBuilder.addPart(key));
    }

    newChildren.toString = parentPath ? function () {
      return pathBuilder.toString();
    } : function () {
      throw new Error("toString() not allowed");
    };
    return newChildren;
  }

  return memberWithChildrenPathPart;
}

function memberSimple() {
  function memberSimplePathPart(id) {
    return this.addPart(id).toString();
  }

  return memberSimplePathPart;
}
/**
 * collection and member path
 * @param collection collection path definition
 * @param member member path definition
 *
 * **example**
 *
 * ```typescript
 * const r = routes({
 *   foos: both(
 *     collection(),
 *     member({
 *       bar: collection(),
 *     }),
 *   ),
 * });
 *
 * r.foos().toString() // "/foos"
 * r.foos(1).toString() // "/foos/1"
 * r.foos(1).bar() // "/foos/1/bar"
 * ```
 */


function both(collection, member) {
  function bothPathPart(id) {
    // tslint:disable-next-line no-null-keyword strict-type-predicates
    return id == null ? collection.call(this) : member.call(this, id);
  }

  return bothPathPart;
}

exports.both = both;